<script setup lang="ts">
import UiButtonMain from '@shared/ui/ButtonMain.vue';

defineProps<{
  isLastStep: boolean;
  canProceed: boolean;
  calculatedPrice: number;
  isLoading?: boolean;
}>();

const emit = defineEmits<{
  (e: 'next'): void;
  (e: 'addToCart'): void;
}>();
</script>

<template>
  <div class="bundle-actions">
    <!-- Тот же CTA-компонент, что и остальные красные кнопки приложения
         (UiButtonMain color="red" — pill rounded-full, бренд-красный red-500) -->
    <UiButtonMain
      v-if="!isLastStep"
      :label="`Далее ${calculatedPrice} ₽`"
      color="red"
      size="xl"
      variant="solid"
      block
      :disabled="!canProceed"
      @click="emit('next')"
    />

    <UiButtonMain
      v-else
      :label="`В корзину ${calculatedPrice} ₽`"
      color="red"
      size="xl"
      variant="solid"
      block
      :disabled="!canProceed || isLoading"
      :loading="isLoading"
      @click="emit('addToCart')"
    />
  </div>
</template>

<style scoped lang="scss">
.bundle-actions {
  @apply px-4 pb-4 pt-2;
}
</style>
